import { createAction, props } from '@ngrx/store';
import { FormMode } from './api-key-form.model';
import {
  ApiKeyCreatedProps,
  ApiKeyErroredProps,
  ApiKeyRequestedProps,
  ApiKeyLoadedProps,
  ApiKeyUpdatedProps,
} from './types';
import { apiKeyFormProjectsAdapter } from './api-key-form.adapter';

export const ApiKeyFormPageRequestedAction = createAction(
  '[Api Key Form] Page Requested',
  props<ApiKeyRequestedProps>(),
);

export const ApiKeyLoadedAction = createAction(
  '[Api Key Form Effect] Api Key Loaded',
  props<ApiKeyLoadedProps>(),
);

export const ApiKeyErroredAction = createAction(
  '[Api Key Form Effect] Api Key Errored',
  props<ApiKeyErroredProps>(),
);

export const ApiKeyFormModeChangedAction = createAction(
  '[Api Key Form] Form Mode Changed',
  props<{ mode?: FormMode }>(),
);

export const CreateApiKeyAction = createAction(
  '[Api Key Form] Create Api Key',
  props<ApiKeyCreatedProps>(),
);

export const ApiKeyCreatedAction = createAction(
  '[Api Key Form Effect] Api Key Created',
  props<ApiKeyLoadedProps>(),
);

export const UpdateApiKeyAction = createAction(
  '[Api Key Form] Update Api Key',
  props<ApiKeyUpdatedProps>(),
);

export const ApiKeyUpdatedAction = createAction(
  '[Api Key Form Effect] Api Key Updated',
  props<ApiKeyLoadedProps>(),
);

export const apiKeyFormProjectsActions = apiKeyFormProjectsAdapter.getActions();
